import { type HTMLAttributes } from "react";

export function Skeleton({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  const cls = [
    "bg-sumi/10 rounded-md animate-pulse",
    className ?? "h-4 w-full",
  ]
    .filter(Boolean)
    .join(" ");
  return <div className={cls} aria-hidden="true" {...rest} />;
}
